<template>
  <div class="mark-detail-announce-wrap">
      <Breadcrumb :options="crumbOptions"></Breadcrumb>
      <div class="title">{{instance.title}}</div>
      <a-row :gutter="[0, 10]">
        <a-col :span="12">
          <div>转让方: {{instance.licensor}}</div>
        </a-col>
        <a-col :span="12">
          <div>运营类型：{{instance.operationTypeStr}}</div>
        </a-col>
        <a-col :span="12">
          <div>受让方: {{instance.licensee}}</div>
        </a-col>
        <a-col :span="12">
          <div>运营日期：{{instance.createTime}}</div>
        </a-col>
        <a-col :span="12">
          <div class="price-wrap">金额: <span class="redItem">{{instance.price === -1 ? '面议' : '￥' + instance.price}}</span></div>
        </a-col>
      </a-row>
      <div class="detail-wrap">
        <span class="title">交易介绍</span>
        <div class="dealTitle">{{instance.content}}</div>
      </div>
      <div class="detail-wrap">
        <span class="title">交易附图</span>
        <div class="pictures">
          <MediaWrap v-for="item in instance.pictures" :key="item" :url="item" :height="220" :isViewer="true"></MediaWrap>
        </div>
      </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/common/Breadcrumb'
import {getAnnounceInfo} from '@/api/tradingInfos.js'
import { getCurrentCrumb } from '@/utils/crumb.js'
import mixinsBackStack from '@/views/backstageSupport/mixins'
export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      instance:{},
      crumbOptions: []
    }
  },
  components: {
    Breadcrumb,
  },
  created() {
    this.settingCrumb()
    this.initRequest()
  },
  methods: {
    settingCrumb() {
      const { path } = this.$route
      const crumbOptions = getCurrentCrumb(path)
      this.crumbOptions = crumbOptions
    },
    async initRequest() {
      const {id} = this.$route.query
      const {data} = await getAnnounceInfo(id)
      data.pictures = []
      if(data.fileVo) {
        data.fileVo.forEach(item => {
          data.pictures.push(item.filePath)
        })
      }
      this.handlerDateFormat([data])
      this.handlerResultMappings([data]) // 处理数据的映射关系
      this.instance = {...data}
    }
  }
}
</script>
